import { render } from "./categoryImage.vue?vue&type=template&id=23294c2f"
import script from "./categoryImage.vue?vue&type=script&lang=js"
export * from "./categoryImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__